import { post } from 'lib/API';

export const createVideo = async ([newVideo, vendorId]: any, { token }: any): Promise<any> => {
  return await post('v1/videos', token, {
    videoId: newVideo.videoId,
    name: newVideo.name,
    vendorId
  });
};
